import { Menu } from "lucide-react";
import { openAnalyticsSettings } from "./analytics.tsx";
import { useLocale } from "./i18n.tsx";

export type Session = { id: string; email: string; name: string; expiresAt: string };

export function BrandLink({ href, label }: { href: string; label?: string }) {
  return <a className="wordmark" href={href} aria-label={label}><img src="/favicon.svg?v=20260829" alt="" width="30" height="30" aria-hidden="true" />NeckMoves</a>;
}

export function LocaleSwitch({ inverted = false, compact = false }: { inverted?: boolean; compact?: boolean }) {
  const { locale, setLocale, copy } = useLocale();
  return (
    <div className={`locale-switch ${inverted ? "inverted" : ""} ${compact ? "compact" : ""}`} role="group" aria-label={copy.common.language}>
      <button type="button" aria-pressed={locale === "zh-CN"} onClick={() => setLocale("zh-CN")}>{copy.common.chinese}</button>
      <button type="button" aria-pressed={locale === "en"} onClick={() => setLocale("en")}>{copy.common.english}</button>
    </div>
  );
}

export function Header({ session }: { session: Session | null }) {
  const { copy, href } = useLocale();
  return (
    <header className="site-header">
      <BrandLink href={href("/")} label={copy.common.home} />
      <nav className="desktop-nav" aria-label={copy.common.menu}>
        <a href={href("/play")}>{copy.common.play}</a>
        <a href={href("/reminders")}>{copy.common.reminders}</a>
        <a href={href("/blog")}>{copy.common.blog}</a>
        <a href={href("/pricing")}>{copy.common.pricing}</a>
        <a href={href(session ? "/account" : "/login")}>{session ? copy.common.account : copy.common.login}</a>
      </nav>
      <div className="header-actions"><LocaleSwitch compact /><a className="button button-primary header-cta" href={href("/play/firefly")}>{copy.common.move}</a></div>
      <details className="mobile-menu">
        <summary aria-label={copy.common.menu}><Menu aria-hidden="true" /></summary>
        <nav aria-label={copy.common.menu}>
          <a href={href("/play")}>{copy.common.play}</a>
          <a href={href("/reminders")}>{copy.common.reminders}</a>
          <a href={href("/blog")}>{copy.common.blog}</a>
          <a href={href("/pricing")}>{copy.common.pricing}</a>
          <a href={href(session ? "/account" : "/login")}>{session ? copy.common.account : copy.common.login}</a>
          <LocaleSwitch />
        </nav>
      </details>
    </header>
  );
}

export function Footer() {
  const { copy, href } = useLocale();
  return (
    <footer className="site-footer">
      <div><BrandLink href={href("/")} label={copy.common.home} /><p>{copy.common.footer}</p></div>
      <nav aria-label={copy.common.menu}>
        <a href={href("/about")}>{copy.common.about}</a>
        <a href={href("/blog")}>{copy.common.blog}</a>
        <a href={href("/legal/privacy")}>{copy.common.privacy}</a>
        <a href={href("/legal/terms")}>{copy.common.terms}</a>
        <a href={href("/product-supplement")}>{copy.common.supplement}</a>
        <button type="button" onClick={openAnalyticsSettings}>{copy.common.cookies}</button>
      </nav>
      <p className="company-line">© {new Date().getUTCFullYear()} SZLK LTD · Registered in England and Wales · Company No. 16843016</p>
    </footer>
  );
}

export function Page({ session, children, className = "" }: { session: Session | null; children: React.ReactNode; className?: string }) {
  return <div className={`page ${className}`}><Header session={session} />{children}<Footer /></div>;
}
